import { Alert, Button, Card, Radio, Space, Steps, Switch, Tag, Typography } from 'antd';
import { MockBanner } from '../../pages/components/MockBanner';
import { PageHeader } from '../../pages/components/PageHeader';

/** Org screen 12 — the one irreversible choice in the product (T-04). */
export function OrgAddInstitutionPage() {
  return (
    <div>
      <MockBanner when="the provisioning module + trust-side copy-forward" />
      <PageHeader
        title="Add Greenwood College"
        subtitle="Copy the Senior school to go live in an afternoon"
        actions={<Button disabled>Save draft</Button>}
      />

      <Steps
        current={0}
        size="small"
        style={{ marginBottom: 16 }}
        items={[{ title: 'Basics' }, { title: 'Copy from existing' }, { title: 'Review & create' }]}
      />

      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) 320px', gap: 12, alignItems: 'flex-start' }}>
        <Space direction="vertical" size={12} style={{ width: '100%' }}>
          <Card size="small" title="Step 1 · The basics">
            <Space direction="vertical" size={10} style={{ width: '100%' }}>
              <Row label="Name" value="Greenwood College" />
              <Row
                label={<>Type <Tag color="error" style={{ marginLeft: 6 }}>PERMANENT</Tag></>}
                value={
                  <Radio.Group defaultValue="college">
                    <Radio.Button value="school">School (K-12)</Radio.Button>
                    <Radio.Button value="college">College / Higher-ed</Radio.Button>
                  </Radio.Group>
                }
                note="Chosen once and irreversible (T-04). Forks the academic spine."
              />
              <Row label="Board / affiliation" value="SPPU" />
              <Row label="Location" value="Warje, Pune" />
              <Row label="First session" value="2026–27" />
              <Row label="Principal contact" value="Dr. A. Bhide · a.bhide@greenwood.edu.in · 98•••441" />
            </Space>
          </Card>

          <Card size="small" title="Step 2 · Copy from an existing institution">
            <Typography.Text type="secondary" style={{ display: 'block', fontSize: 12.5, marginBottom: 12 }}>
              Bring settings across from Greenwood Senior. Anything you don't copy comes as a blank
              setup step later.
            </Typography.Text>
            <CopyRow label="Students" note="new students not applicable across a college" value={false} />
            <CopyRow label="Staff" note="carry only shared employees" value="partial" />
            <CopyRow label="Calendar" note="terms and holidays — usually differ; edit after" value={true} />
            <CopyRow label="Fee structure" note="expect to customize per-course after" value="partial" />
            <CopyRow label="Timetable" note="never copyable — colleges are course-registered, not timetabled" value={false} />
            <CopyRow label="Roles" note="clerk, accounts and gatekeeper cross well" value={true} />
          </Card>
        </Space>

        <Space direction="vertical" size={12} style={{ width: '100%' }}>
          <Card size="small" title="What creating makes">
            <Row2 count={1} text="Institution ORG-... / gw-college" />
            <Row2 count={1} text="Session 2026–27 marked Active" />
            <Row2 count={0} text="Students · yours to add" />
            <Row2 count={4} text="Roles copied from Senior" />
            <Row2 count={1} text="Owner Membership for Dr. Bhide" />
          </Card>

          <Alert
            type="warning"
            showIcon
            message="Before you press it"
            description={
              <Typography.Text style={{ fontSize: 12.5, color: '#7d5610' }}>
                Type is permanent. A school that later opens a junior college adds a <b>second</b> Institution; it does not convert this one.
              </Typography.Text>
            }
          />

          <Button type="primary" size="large" block disabled>
            Copy Senior and go live
          </Button>
        </Space>
      </div>
    </div>
  );
}

function Row({ label, value, note }: { label: React.ReactNode; value: React.ReactNode; note?: string }) {
  return (
    <div>
      <div style={{ fontSize: 10.5, letterSpacing: 0.4, textTransform: 'uppercase', color: '#8a94a6', fontWeight: 600, marginBottom: 4 }}>{label}</div>
      <div style={{ padding: '6px 10px', border: '1px solid #dcdde3', borderRadius: 6, background: '#fff', fontSize: 13 }}>{value}</div>
      {note && <Typography.Text type="secondary" style={{ fontSize: 11.5, display: 'block', marginTop: 4 }}>{note}</Typography.Text>}
    </div>
  );
}

function CopyRow({ label, note, value }: { label: string; note: string; value: boolean | 'partial' }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: 12, padding: '10px 0', borderBottom: '1px solid #f1f1f4', alignItems: 'center' }}>
      <div>
        <div style={{ fontWeight: 500, fontSize: 13 }}>{label}</div>
        <Typography.Text type="secondary" style={{ fontSize: 11.5 }}>{note}</Typography.Text>
      </div>
      <div>
        {value === 'partial' ? (
          <Tag color="warning">Partial · you'll pick</Tag>
        ) : (
          <Switch size="small" defaultChecked={value} disabled />
        )}
      </div>
    </div>
  );
}

function Row2({ count, text }: { count: number; text: string }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '30px 1fr', gap: 8, padding: '4px 0' }}>
      <Tag color={count === 0 ? undefined : 'success'} style={{ margin: 0, minWidth: 24, textAlign: 'center' }}>{count}</Tag>
      <Typography.Text style={{ fontSize: 12.5, color: count === 0 ? '#5b6478' : '#14213d' }}>{text}</Typography.Text>
    </div>
  );
}
